module.exports = __webpack_public_path__ + "static/img/byconcept-landing.de538a5.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/byconcept-landing.webp
// module id = 73
// module chunks = 0